var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogosSlackIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 34,
    viewBox: "0 0 35 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1025_46427)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.68335 21.425C7.68335 23.3949 6.10988 24.9871 4.16297 24.9871C2.21605 24.9871 0.642578 23.3949 0.642578 21.425C0.642578 19.4553 2.21605 17.8633 4.1631 17.8633H7.68322V21.4252L7.68335 21.425ZM9.44361 21.425C9.44361 19.4553 11.0171 17.8633 12.964 17.8633C14.9109 17.8633 16.4844 19.4553 16.4844 21.4252V30.3299C16.4844 32.2997 14.9109 33.8919 12.9639 33.8919C11.0172 33.8919 9.44361 32.2997 9.44361 30.3299V21.4252V21.425Z",
    fill: "#E01E5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9633 7.1238C11.0164 7.1238 9.44278 5.53177 9.44278 3.5619C9.44278 1.59202 11.0165 0 12.9633 0C14.9101 0 16.4837 1.59202 16.4837 3.5619V7.12393H12.9632L12.9633 7.1238ZM12.9633 8.93177C14.9102 8.93177 16.4837 10.5238 16.4837 12.4937C16.4837 14.4635 14.9102 16.0556 12.9632 16.0556H4.13575C2.1887 16.0556 0.615234 14.4635 0.615234 12.4935C0.615234 10.5239 2.1887 8.93177 4.13562 8.93177H12.9632H12.9633Z",
    fill: "#36C5F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.0706 12.4937C27.0706 10.5238 28.644 8.93164 30.5908 8.93164C32.5377 8.93164 34.1113 10.5238 34.1113 12.4937C34.1113 14.4635 32.5377 16.0556 30.5908 16.0556H27.0706V12.4935V12.4937ZM25.3103 12.4937C25.3103 14.4635 23.7367 16.0556 21.7898 16.0556C19.843 16.0556 18.2695 14.4635 18.2695 12.4935V3.56203C18.2695 1.59202 19.843 0 21.7898 0C23.7366 0 25.3102 1.59202 25.3102 3.5619V12.4935L25.3103 12.4937Z",
    fill: "#2EB67D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.7898 26.7681C23.7367 26.7681 25.3103 28.3601 25.3103 30.3299C25.3103 32.2997 23.7367 33.8919 21.7898 33.8919C19.843 33.8919 18.2695 32.2997 18.2695 30.3299V26.7681H21.7899H21.7898ZM21.7898 24.9871C19.843 24.9871 18.2695 23.3949 18.2695 21.425C18.2695 19.4553 19.843 17.8633 21.7899 17.8633H30.6175C32.5644 17.8633 34.138 19.4553 34.138 21.4252C34.138 23.3949 32.5644 24.9871 30.6175 24.9871H21.7899H21.7898Z",
    fill: "#ECB22E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1025_46427"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 33.6038,
    height: 34,
    fill: "white",
    transform: "translate(0.615234)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogosSlackIcon);
export default __webpack_public_path__ + "static/media/logos_slack-icon.81d644e94b34cce03e5b2b2e25ab99f7.svg";
export { ForwardRef as ReactComponent };